import axios from 'axios' 
import router from '@/components/mainConfig/routerConfig'
import {Message} from 'element-ui'
const axiosConfig=axios.create({
    // baseURL:'http://192.168.31.1:8081',
    // timeout:5000
})
axiosConfig.interceptors.request.use(config=>{
    if (config.push === '/') { 
    } else { 
   if (localStorage.getItem('token')) { 
        //在请求头加入token，名字要和后端接收请求头的token名字一样    
      config.headers.token=localStorage.getItem('token');        
     }   
   }  
   config.headers['Access-Control-Allow-Origin'] = '*'; // 允许来自特定域的请求访问
    return config;  

  },  
  error => { 
     return Promise.reject(error);
  },
  axiosConfig.interceptors.response.use(response => {  
     console.log('响应回来：',response)  
      if (response.data.status == 0) {
              // 引用elementui message提示框       
              Message({        
                  message: '身份已失效',  
                  type: 'err'        
                  });
              //清除token  
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              //跳转 
               router.push({name: 'Login'});  
               return false  
          } else { 
                  return response  
          }  
     }, 
  error => { 
    if(error.response.status==403){
        Message({        
                  message: '身份已失效',  
                  type: 'err'        
                  });
              //清除token  
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              //跳转 
               router.push({name: 'Login'});  
               return false  
    }
   return Promise.reject(error);  
   }
   )
  )

  export default axiosConfig


// WEBPACK FOOTER //
// ./src/components/mainConfig/axiosConfig.js